import axios from 'axios';
import { API_URL, MANAGING_VESSEL } from './ConstantService';

export const ManagingVesselService = {
  async getAllManagingVessel(page = 1, perPage = 10) {
    try {
      const response = await axios.get(`${API_URL}${MANAGING_VESSEL}?page=${page}&per_page=${perPage}`);
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return { error: true, data: error.response.data };
      }
      return { error: true, data: { message: 'Something went wrong' } };
    }
  },

  async showManagingVessel(id) {
    try {
      const response = await axios.get(API_URL + MANAGING_VESSEL + '/' + id);
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return { error: true, data: error.response.data };
      }
      return { error: true, data: { message: 'Something went wrong' } };
    }
  },

  async storeManagingVessel(data) {
    try {
      const response = await axios.post(`${API_URL}${MANAGING_VESSEL}`, data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return { error: true, data: error.response.data };
      }
      return { error: true, data: { message: 'Something went wrong' } };
    }
  },

  async updateManagingVessel(id, data) {
    try {
      const response = await axios.put(API_URL + MANAGING_VESSEL + '/' + id, data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return { error: true, data: error.response.data };
      }
      return { error: true, data: { message: 'Something went wrong' } };
    }
  },

  async destroyManagingVessel(id, password) {
    try {
      const response = await axios.delete(API_URL + MANAGING_VESSEL + '/' + id, { data: { password } });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return { error: true, data: error.response.data };
      }
      return { error: true, data: { message: 'Something went wrong' } };
    }
  }
};
